import { render } from "solid-js/web";
import { PrivateBetaApp } from "./PrivateBetaApp";

const mount = () => {
	render(() => <PrivateBetaApp />, document.body);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", mount);
} else {
	mount();
}
